import { Box, Skeleton, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectTotalPrice,
  selectTotalPriceServices,
} from "../../redux/selectors/selectors";
import { useEffect, useState } from "react";
import { getCheckoutTotalWithFee, getPlatformFee, getGatewayFeeAmount } from "../../common/utils";
import { useTranslation } from "react-i18next";

export default function Basket({
  invoiceId,
  bookingId,
  cartItems,
  loading,
  paymentType,
  totalPrice,
  setTotalPrice,
  selectedPaymentMethodName,
  cartItemsList,
}) {

  const { t } = useTranslation();

  const totalPriceAdditionalServices = useSelector(
    paymentType === "services" ? selectTotalPriceServices : selectTotalPrice
  );

  const [skeleton, setSekeleton] = useState(true);



  useEffect(() => {
    if (invoiceId || bookingId) {
      if (Object.keys(cartItems)?.length) {
        setSekeleton(false);
      }
    }

    if (cartItems?.length) {
      let totalPriceInvoices =
        cartItems?.reduce((total, cartItem) => {
          return total + Number(cartItem.payment_amount);
        }, 0) || 0;

      if (invoiceId) {
        setTotalPrice(totalPriceInvoices);
      } else if (bookingId) {
        setTotalPrice(cartItems.total_price);
      } else {
        if (paymentType === "services") {
        }
        setTotalPrice(totalPriceAdditionalServices);
      }
    }
  }, [invoiceId, bookingId, cartItems, paymentType, setTotalPrice, totalPriceAdditionalServices]);

  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  return (
    <Box
      sx={{
        borderRadius: "1rem",
        height: "100%",
        backgroundColor: lightMode ? "#FCFCFC" : "#282828",
        filter: "drop-shadow(0px 3px 6px #00000029)",
        padding: { xs: "1rem", lg: "2rem" },
      }}
    >
      <Typography
        sx={{
          fontSize: "24px",
          borderBottom: "1px solid #e6e6e6",
          paddingBottom: ".5rem",
          marginBottom: "2rem",
          textTransform: 'capitalize'
        }}
      >
        {invoiceId
          ? `
            ${t("invoiceNumber")}: ${invoiceId}
        `
          : bookingId
            ? `
        ${t("bookingNumber")}: ${bookingId}
    `
            : t("yourBasket")}
      </Typography>
      {!invoiceId && !bookingId ? (
        Array.isArray(cartItems) ? (
          cartItems.length ? (
          cartItems?.map((cartItem, idx) => {
            return (
              <Box
                key={cartItem.service_id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: idx + 1 !== cartItems?.length ? "1rem" : "0",
                }}
              >
                <Box
                  sx={{
                    marginRight: "0.5rem",
                    borderRadius: "10rem",
                    background: "#ebebeb",
                    minWidth: "56px",
                    minHeight: "56px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    filter: "drop-shadow(0px 3px 6px #00000029)",
                  }}
                >
                  <img
                    src={cartItem.image}
                    alt={cartItem.service_name || ""}
                    width={50}
                    height={50}
                    style={{ borderRadius: "100%" }}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",

                      lineHeight: "20px",
                    }}
                  >
                    {cartItem.service_name}
                    {cartItem?.selectedSize
                      ? `- ` + cartItem?.selectedSize
                      : ``}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      marginLeft: { xs: "unset", md: "auto" },
                      marginTop: { xs: ".5rem", md: "unset" },
                      lineHeight: "20px",
                    }}
                  >
                    £{cartItem.price} x {cartItem.quantity}
                  </Typography>
                </Box>
              </Box>
            );
          })
        ) : (
          `Your basket is empty`
        )
        ) : cartItemsList?.length ? (
          cartItemsList.map((cartItem, idx) => {
            return (
              <Box
                key={cartItem.service_id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: idx + 1 !== cartItemsList?.length ? "1rem" : "0",
                }}
              >
                <Box
                  sx={{
                    marginRight: "0.5rem",
                    borderRadius: "10rem",
                    background: "#ebebeb",
                    minWidth: "56px",
                    minHeight: "56px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    filter: "drop-shadow(0px 3px 6px #00000029)",
                  }}
                >
                  <img
                    src={cartItem.image}
                    alt={cartItem.service_name || ""}
                    width={50}
                    height={50}
                    style={{ borderRadius: "100%" }}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      lineHeight: "20px",
                    }}
                  >
                    {cartItem.service_name}
                    {cartItem?.selectedSize ? `- ` + cartItem?.selectedSize : ``}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      marginLeft: { xs: "unset", md: "auto" },
                      marginTop: { xs: ".5rem", md: "unset" },
                      lineHeight: "20px",
                    }}
                  >
                    £{cartItem.price} x {cartItem.quantity}
                  </Typography>
                </Box>
              </Box>
            );
          })
        ) : null
      ) : (
        <>
          {loading ? (
            <Box>
              {Array.from({ length: 5 }, (_, index) => (
                <Skeleton
                  key={index}
                  sx={{
                    height: index === 4 ? "50px" : "30px",
                    marginTop: index === 4 ? "2rem" : "0",
                  }}
                  animation="wave"
                />
              ))}
            </Box>
          ) : cartItems?.payments?.length && !cartItems?.services?.length ? (
            <>
              {Object.keys(cartItems?.campus)?.length ? (
                <Box
                  sx={{
                    marginBottom: "1rem",
                  }}
                >
                  {skeleton ? (
                    <Skeleton>
                      <Typography>{cartItems?.campus?.campus_name}</Typography>
                    </Skeleton>
                  ) : (
                    <Box sx={{ display: "flex" }}>
                      <img
                        style={{ borderRadius: ".5rem", objectFit: "cover" }}
                        src={cartItems?.campus?.logo}
                        alt={cartItems?.campus?.campus_name || ""}
                        width={100}
                        height={100}
                      />
                      <Typography textTransform={"capitalize"} variant="h6" sx={{ marginLeft: "1rem" }}>
                        {cartItems?.campus?.campus_name}
                      </Typography>
                    </Box>
                  )}
                </Box>
              ) : null}
              {cartItems?.payments?.map((cartItem, idx) => {
                return cartItem.outstanding_amount !== 0 ? (
                  <Box
                    key={`${cartItem?.payment_id} - ${idx}`}
                    sx={{
                      marginBottom: "1rem",
                      borderBottom: `${idx + 1 !==
                        cartItems.payments.filter((cartItem, idx) => {
                          return cartItem.outstanding_amount !== 0;
                        })?.length
                        ? "1px solid #e6e6e6"
                        : "unset"
                        }`,
                      paddingBottom: `${idx + 1 !==
                        cartItems.payments.filter((cartItem, idx) => {
                          return cartItem.outstanding_amount !== 0;
                        })?.length
                        ? "1rem"
                        : "0"
                        }`,
                    }}
                  >
                    {skeleton ? (
                      <Skeleton>
                        <Typography>
                          Payment ID: {cartItem.payment_id}
                        </Typography>
                      </Skeleton>
                    ) : (
                      <>
                        <Typography>
                          Payment ID: {cartItem.payment_id}
                        </Typography>
                        <Typography>
                          Payment Type: {cartItem.payment_type === 'deposit'
                            ? t('deposit')
                            : cartItem.payment_type === 'down_payment'
                              ? t('downPayment')
                              : cartItem.payment_type?.replace(/_/g, ' ')}
                        </Typography>
                        <Typography>Due Date: {cartItem.due_date}</Typography>
                        <Typography>
                          Outstanding Amount: {paraFormat(Number(cartItem.outstanding_amount || 0))}
                        </Typography>
                      </>
                    )}
                  </Box>
                ) : null;
              })}
            </>
          ) : cartItems?.room_information ? (
            <Box
              sx={{
                marginBottom: "1rem",
              }}
            >
              {skeleton ? (
                <Skeleton>
                  <Typography>{cartItems?.room_information?.name}</Typography>
                </Skeleton>
              ) : (
                <>
                  <Box sx={{ display: "flex" }}>
                    <img
                      style={{ borderRadius: ".5rem", objectFit: "cover" }}
                      src={cartItems?.room_information?.image}
                      alt={cartItems?.room_information?.name || ""}
                      width={100}
                      height={100}
                    />
                    <Typography textTransform={"capitalize"} variant="h6" sx={{ marginLeft: "1rem" }}>
                      {cartItems?.room_information?.name}
                    </Typography>
                  </Box>

                  {cartItems?.promotion_amount ? (
                    <Box
                      sx={{
                        backgroundColor: "#0080002b",
                        padding: "1rem",
                        marginTop: "1rem",
                        borderRadius: "1rem",
                      }}
                    >
                      {cartItems?.promotion_amount ? (
                        <Box>
                          <Typography>
                            <strong> Promotion Amount: </strong>{" "}
                            {paraFormat(cartItems?.promotion_amount)}
                          </Typography>
                        </Box>
                      ) : null}
                      {cartItems?.promotion_percentage ? (
                        <Box>
                          <Typography>
                            <strong>Promotion Percentage: </strong>%
                            {cartItems?.promotion_percentage}
                          </Typography>
                        </Box>
                      ) : null}
                      {cartItems?.promotion_fixed ? (
                        <Box>
                          <Typography>
                            <strong>Promotion Fixed: </strong>
                            {cartItems?.promotion_fixed}
                          </Typography>
                        </Box>
                      ) : null}
                      {cartItems?.discounted_price ? (
                        <Box>
                          <Typography>
                            <strong>Discounted Price: </strong>
                            {paraFormat(cartItems?.discounted_price)}
                          </Typography>
                        </Box>
                      ) : null}
                      {cartItems?.promotion_name ? (
                        <Box>
                          <Typography>
                            <strong> Promotion Name:</strong>{" "}
                            {cartItems?.promotion_name}
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>
                  ) : null}
                </>
              )}
            </Box>
          ) : cartItems?.services?.length ? (
            cartItems?.services?.map((cartItem, idx) => {
              return (
                <Box
                  key={idx}
                  sx={{
                    marginBottom: "1rem",
                  }}
                >
                  {skeleton ? (
                    <Skeleton>
                      <Typography>{cartItem?.service?.service_name}</Typography>
                    </Skeleton>
                  ) : (
                    <>
                      <Box sx={{ display: "flex" }}>
                        <img
                          style={{ borderRadius: ".5rem", objectFit: "cover" }}
                          src={cartItem?.service?.image}
                          alt={cartItem?.service?.service_name || ""}
                          width={100}
                          height={100}
                        />
                        <Typography textTransform={"capitalize"} variant="h6" sx={{ marginLeft: "1rem" }}>
                          {cartItem?.service?.service_name}
                        </Typography>
                      </Box>
                      {cartItem?.details ? (
                        <Box sx={{ marginTop: "1rem" }}>
                          {cartItem?.details &&
                            cartItem?.details?.flight_number ? (
                            <>
                              <Typography textTransform={"capitalize"} variant="h6">
                                <strong>{t("airportTransfer.to")}: </strong> {cartItem?.details?.to}
                              </Typography>
                              <Typography textTransform={"capitalize"} variant="h6">
                                <strong>{t("airportTransfer.from")}: </strong> {cartItem?.details?.from}
                              </Typography>
                              <Typography textTransform={"capitalize"} variant="h6">
                                <strong>{t("peopleCount")}: </strong>{" "}
                                {cartItem?.details?.people}
                              </Typography>
                              <Typography textTransform={"capitalize"} variant="h6">
                                <strong>{t("flightNumber")}: </strong>{" "}
                                {cartItem?.details?.flight_number}
                              </Typography>
                              <Typography textTransform={"capitalize"} variant="h6">
                                <strong>{t("airportTransfer.transportationDateTime")}: </strong>{" "}
                                {cartItem?.details?.transportation_date_time}
                              </Typography>
                              {/* <Typography textTransform={"capitalize"} variant="h6">
                                <strong>Travel Type: </strong>{" "}
                                {cartItem?.details?.travel_type}
                              </Typography> */}
                            </>
                          ) : cartItem?.details?.cleaning_date ? (
                            <Typography textTransform={"capitalize"} variant="h6">
                              <strong>{t("cleaningDate")}: </strong>{" "}
                              {cartItem?.details?.cleaning_date}
                            </Typography>
                          ) : null}
                        </Box>
                      ) : null}
                    </>
                  )}
                </Box>
              );
            })
          ) : cartItems?.details ? (
            <Box
              sx={{
                marginBottom: "1rem",
              }}
            >
              {skeleton ? (
                <Skeleton>
                  <Typography></Typography>
                </Skeleton>
              ) : (
                <>
                  {cartItems?.details ? (
                    <Box sx={{ marginTop: "1rem" }}>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("airportTransfer.from")}:</strong>{" "}
                        {cartItems?.details?.travel_type === "Arrival"
                          ? cartItems?.details?.service_name
                          : cartItems?.details?.residence_name}
                      </Typography>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("airportTransfer.to")}:</strong>{" "}
                        {cartItems?.details?.travel_type === "Arrival"
                          ? cartItems?.details?.residence_name
                          : cartItems?.details?.service_name}
                      </Typography>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("peopleCount")}:</strong>{" "}
                        {cartItems?.details?.people_count}
                      </Typography>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("flightNumber")}: </strong>{" "}
                        {cartItems?.details?.flight_number}
                      </Typography>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("airportTransfer.transportationDateTime")}: </strong>{" "}
                        {cartItems?.details?.transportation_date_time}
                      </Typography>
                      <Typography textTransform={"capitalize"} variant="h6">
                        <strong>{t("travelType")}: </strong>{" "}
                        {cartItems?.details?.travel_type}
                      </Typography>
                    </Box>
                  ) : null}
                </>
              )}
            </Box>
          ) : null}
        </>
      )}
       {!invoiceId && !bookingId ? (
        Array.isArray(cartItems) ? (
          (() => {
            const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(totalPrice);
            const showFee = Number(fee) > 0;
            return (
              <>
                {showFee ? (
                  <Typography
                    color="primary"
                    sx={{
                      fontSize: "24px",
                      marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                    }}
                  >
                    {"Platform Fee"} {paraFormat(fee)}
                  </Typography>
                ) : null}
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {t("totalPrice")} £{(Number(totalPrice) + Number(fee)).toFixed(2)}
                </Typography>
              </>
            );
          })()
        ) : (
          // When services/shop uses checkout response object
          cartItems && (
            (() => {
              const totalWithFee = Number(getCheckoutTotalWithFee(cartItems, selectedPaymentMethodName) ?? 0);
              const knownFee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName);
              if (knownFee != null) {
                const showFee = Number(knownFee) > 0;
                return (
                  <>
                    {showFee ? (
                      <Typography
                        color="primary"
                        sx={{
                          fontSize: "24px",
                          marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                        }}
                      >
                        {"Platform Fee"} {paraFormat(knownFee)}
                      </Typography>
                    ) : null}
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: "24px",
                        marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                      }}
                    >
                      {t("totalPrice")} {paraFormat(totalWithFee)}
                    </Typography>
                  </>
                );
              }
              const fallbackBase = Number(cartItems?.total_amount ?? cartItems?.total_price ?? 0);
              const fee = getPlatformFee(fallbackBase);
              const showFee = Number(fee) > 0;
              return (
                <>
                  {showFee ? (
                    <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' } }}>
                      {"Platform Fee"} {paraFormat(fee)}
                    </Typography>
                  ) : null}
                  <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' } }}>
                    {t("totalPrice")} {paraFormat(fallbackBase + fee)}
                  </Typography>
                </>
              );
            })()
          )
        )
      ) : cartItems?.payments?.length ? (
        (() => {
          const base = (cartItems?.payments || [])
            .reduce((sum, p) => sum + Number(p?.outstanding_amount || 0), 0);
          const latePenalty = Number(cartItems?.late_penalty_total || 0);
          const overdueInterest = Number(cartItems?.overdue_interest_total || 0);
          const amountBeforeGatewayFee = Number(
            cartItems?.total_amount ?? cartItems?.excluded_fee_price ?? (base + latePenalty + overdueInterest)
          );
          const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(amountBeforeGatewayFee);
          const showFee = Number(fee) > 0;
          const totalWithFee = Number(
            getCheckoutTotalWithFee(cartItems, selectedPaymentMethodName) ?? (amountBeforeGatewayFee + fee)
          );
          return (
            <>
              <Typography
                color="primary"
                sx={{
                  fontSize: "24px",
                  marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                }}
              >
                {"Payment Amount"} £{base.toFixed(2)}
              </Typography>
              {latePenalty > 0 ? (
                <Typography
                  color="primary"
                  title="Not included in invoice total / paid amount."
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                  }}
                >
                  {"Late Payment Charges"} {paraFormat(latePenalty)}
                </Typography>
              ) : null}
              {overdueInterest > 0 ? (
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                  }}
                >
                  {"Overdue Interest"} {paraFormat(overdueInterest)}
                </Typography>
              ) : null}
              {showFee ? (
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                  }}
                >
                  {"Platform Fee"} {paraFormat(fee)}
                </Typography>
              ) : null}
              <Typography
                color="primary"
                sx={{
                  fontSize: "24px",
                  marginTop: { xs: showFee || latePenalty > 0 || overdueInterest > 0 ? ".5rem" : "1.5rem", lg: showFee || latePenalty > 0 || overdueInterest > 0 ? "1rem" : "3rem", textTransform: 'capitalize' },
                }}
              >
                {t("totalPrice")} £{totalWithFee.toFixed(2)}
              </Typography>
            </>
          );
        })()
      ) : bookingId && cartItems && (cartItems.total_amount !== undefined || cartItems.total_price !== undefined) ? (
        (() => {
          const selectedMethod = selectedPaymentMethodName?.toLowerCase();
          const methodObj = cartItems?.[selectedMethod];
          const platformFeeAmount = Number(methodObj?.platform_fee_amount || 0);
          const priceAmount = Number(cartItems?.total_price || cartItems?.total_amount || 0);
          const showFee = Number(platformFeeAmount) > 0 && Object.keys(methodObj || {}).length > 0;
          const totalWithFee = priceAmount + platformFeeAmount;
          const paymentType = cartItems?.payment_type || selectedPaymentMethodName;
          
          return (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {paymentType === 'down_payment'
                    ? t('downPayment')
                    : paymentType === 'deposit'
                      ? t('deposit')
                      : paymentType}
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {paraFormat(priceAmount)}
                </Typography>
              </Box>
              {showFee ? (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: "24px",
                        marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                      }}
                    >
                      {"Platform fee"}
                    </Typography>
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: "24px",
                        marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                      }}
                    >
                      {paraFormat(platformFeeAmount)}
                    </Typography>
                  </Box>
                </>
              ) : null}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {t("totalPrice")}
                </Typography>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {paraFormat(showFee ? totalWithFee : priceAmount)}
                </Typography>
              </Box>
            </>
          );
        })()
      ) : cartItems?.details ? (
        (() => {
          const totalWithFee = Number(
            getCheckoutTotalWithFee(cartItems?.payment, selectedPaymentMethodName) ?? 0
          );
          const knownFee = getGatewayFeeAmount(cartItems?.payment, selectedPaymentMethodName);
          if (knownFee != null) {
            const amountExcludingFee = Math.max(0, totalWithFee - Number(knownFee || 0));
            const showFee = Number(knownFee) > 0;
            return (
              <>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {"Amount"} {paraFormat(amountExcludingFee)}
                </Typography>
                {showFee ? (
                  <Typography
                    color="primary"
                    sx={{
                      fontSize: "24px",
                      marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' },
                    }}
                  >
                    {"Platform Fee"} {paraFormat(knownFee)}
                  </Typography>
                ) : null}
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "24px",
                    marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                  }}
                >
                  {t("totalPrice")} {paraFormat(totalWithFee)}
                </Typography>
              </>
            );
          }
          const fee = getPlatformFee(totalWithFee);
          const showFee = Number(fee) > 0;
          return (
            <>
              <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' } }}>
                {"Amount"} {paraFormat(totalWithFee)}
              </Typography>
              {showFee ? (
                <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: ".5rem", lg: "1rem", textTransform: 'capitalize' } }}>
                  {"Platform Fee"} {paraFormat(fee)}
                </Typography>
              ) : null}
              <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' } }}>
                {t("totalPrice")} {paraFormat(totalWithFee + fee)}
              </Typography>
            </>
          );
        })()
      ) : (
        <>
          {(() => {
            const feeTotal = getCheckoutTotalWithFee(
              cartItems,
              selectedPaymentMethodName
            );
            if (feeTotal != null) {
              const knownFee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName);
              const fee = knownFee != null ? Number(knownFee) : getPlatformFee(feeTotal);
              const showFee = Number(fee) > 0;
              return (
                <>
                  {showFee ? (
                    <Typography
                      color="primary"
                      sx={{
                        fontSize: "24px",
                        marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                      }}
                    >
                      {"Platform Fee"} {paraFormat(fee)}
                    </Typography>
                  ) : null}
                  <Typography color="primary" sx={{ fontSize: "24px", marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' } }}>
                    {t("totalPrice")} {paraFormat(knownFee != null ? feeTotal : feeTotal + fee)}
                  </Typography>
                </>
              );
            }
            return cartItems.services
              ? Object.keys(cartItems?.services)?.length
                ? cartItems?.promotion_amount
                  ? (() => {
                      const base = (cartItems.discounted_price + cartItems?.services?.service_amount);
                      const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(base);
                      const showFee = Number(fee) > 0;
                      return (
                        <>
                          {showFee ? (
                            <Typography
                              color="primary"
                              sx={{
                                fontSize: "24px",
                                marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                              }}
                            >
                              {"Platform Fee"} {paraFormat(fee)}
                            </Typography>
                          ) : null}
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: "24px",
                              marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                            }}
                          >
                            {t("totalPrice")} {paraFormat(base + fee)}
                          </Typography>
                        </>
                      );
                    })()
                  : (() => {
                      const base = (cartItems.total_price + cartItems?.services?.service_amount);
                      const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(base);
                      const showFee = Number(fee) > 0;
                      return (
                        <>
                          {showFee ? (
                            <Typography
                              color="primary"
                              sx={{
                                fontSize: "24px",
                                marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                              }}
                            >
                              {"Platform Fee"} {paraFormat(fee)}
                            </Typography>
                          ) : null}
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: "24px",
                              marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                            }}
                          >
                            {t("totalPrice")} {paraFormat(base + fee)}
                          </Typography>
                        </>
                      );
                    })()
                : cartItems?.promotion_amount
                  ? (() => {
                      const base = cartItems.discounted_price;
                      const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(base);
                      const showFee = Number(fee) > 0;
                      return (
                        <>
                          {showFee ? (
                            <Typography
                              color="primary"
                              sx={{
                                fontSize: "24px",
                                marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                              }}
                            >
                              {"Platform Fee"} {paraFormat(fee)}
                            </Typography>
                          ) : null}
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: "24px",
                              marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                            }}
                          >
                            {t("totalPrice")} {paraFormat(base + fee)}
                          </Typography>
                        </>
                      );
                    })()
                  : (() => {
                      const base = cartItems.total_price;
                      const fee = getGatewayFeeAmount(cartItems, selectedPaymentMethodName) ?? getPlatformFee(base);
                      const showFee = Number(fee) > 0;
                      return (
                        <>
                          {showFee ? (
                            <Typography
                              color="primary"
                              sx={{
                                fontSize: "24px",
                                marginTop: { xs: "1.5rem", lg: "3rem", textTransform: 'capitalize' },
                              }}
                            >
                              {"Platform Fee"} {paraFormat(fee)}
                            </Typography>
                          ) : null}
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: "24px",
                              marginTop: { xs: showFee ? ".5rem" : "1.5rem", lg: showFee ? "1rem" : "3rem", textTransform: 'capitalize' },
                            }}
                          >
                            {t("totalPrice")} {paraFormat(base + fee)}
                          </Typography>
                        </>
                      );
                    })()
              : null;
          })()}
        </>
      )}
    </Box>
  );
}
